const initialState = {
    statusShow: false,
    order: {},
    loader:false,
};
const modalOrderDetails = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_STATUS_SHOW_MODAL_ORDER_DETAILS':
            return {...state, statusShow: action.statusShow};
        case 'GET_DATA_INVOICE_IN_API_ORDER_DETAILS':
            return {...state, order: action.order};
        case 'CHANGE_LOADER_MODAL_ORDER_DETAILS':
            return {...state, loader: action.loader};
        default:
            return state;
    }
};

export default modalOrderDetails;
